import { useTranslation } from 'react-i18next';

export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <div className="flex items-center justify-end gap-2">
      <button
        className={`rounded px-2 py-1 text-sm font-medium transition-colors ${current === 'fr' ? 'font-semibold' : 'text-neutral-500'}`}
        style={
          current === 'fr'
            ? {
                backgroundColor: 'var(--marque-accent)',
                color: 'var(--marque-sur-accent)',
              }
            : undefined
        }
        onClick={() => i18n.changeLanguage('fr')}
        aria-label="Français"
      >
        FR
      </button>
      <span className="text-neutral-400">|</span>
      <button
        className={`rounded px-2 py-1 text-sm font-medium transition-colors ${current === 'en' ? 'font-semibold' : 'text-neutral-500'}`}
        style={
          current === 'en'
            ? {
                backgroundColor: 'var(--marque-accent)',
                color: 'var(--marque-sur-accent)',
              }
            : undefined
        }
        onClick={() => i18n.changeLanguage('en')}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};
